import _ from 'lodash'
import { localeToKebabCase, slugify } from "@/common/helpers"
import {VIEW_URL} from "@/common/config";

const mixins = {
    computed: {
        technicalNotices() {
            if(this.productDatas && this.productDatas.values.reference_name){
                return [
                    {
                        identifier: 'technical',
                        name: this.$t('full_technical_sheet'),
                        link: VIEW_URL+`/machines/${this.productDatas.identifier}?locale=${localeToKebabCase(this.$store.state.settings.locale)}&unit=${this.$store.state.settings.unitType}&format=pdf`,
                        extension: 'pdf',
                        filename: `${slugify(this.productDatas.values['reference_name'].label)}-technical-notice.pdf`,
                        forceLinkDownload: true
                    },
                    /*{
                        identifier: 'synthetical',
                        name: this.$t('short_technical_sheet'),
                        link: 'https://technical-datasheet.manitou.com/machines/'+this.productDatas.identifier,
                        extension: 'pdf'
                    },*/
                ]
            }
            return null;
        },
    }
};

export default mixins;
